import { Modal } from "./style";

export const StatusesAdminModal = ({component}: { component: React.ReactNode}) => {
  
  return (
    <Modal>
      {component}
    </Modal>
  );
};import { Modal } from "./style";

export const StatusesAdminModal = ({component}: { component: React.ReactNode}) => {
  
  return (
    <Modal>
      {component}
    </Modal>
  );
};